module.exports = __webpack_public_path__ + "static/img/1.b7853e6a.png";